import { useRef, useState } from 'react';

import { useDeviceType } from '@braskai/ui-kit';

import { DesktopNav } from '../DesktopNav';
import { SContainer, SDrawer } from './styled';

type DesktopSidebarProps = {
  lockedSidebar?: boolean;
  handleLockedSidebar?: () => void;
};

export const DesktopSidebar = ({ lockedSidebar, handleLockedSidebar }: DesktopSidebarProps) => {
  const { isDesktop, isLaptop } = useDeviceType();

  const [isOpen, setIsOpen] = useState(false);

  const [hardClose, setIsHardClose] = useState(false);

  const drawerRef = useRef<HTMLDivElement | null>(null);

  const onClickLock = () => {
    handleLockedSidebar?.();

    // TODO need reworked without css
    // force close sidebar
    const drawerElement = drawerRef.current;
    setIsHardClose(true);
    if (drawerElement) {
      const onTransitionEnd = () => {
        setIsHardClose(false);
        drawerElement.removeEventListener('transitionend', onTransitionEnd);
      };
      drawerElement.addEventListener('transitionend', onTransitionEnd);
    }
  };

  const onMouseEnter = () => setIsOpen(true);
  const onMouseLeave = () => setIsOpen(false);

  if (!isDesktop && !isLaptop) {
    return null;
  }

  return (
    <SContainer $locked={lockedSidebar}>
      <SDrawer $hardClose={hardClose} $locked={lockedSidebar} ref={drawerRef} variant='permanent' open
               onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <DesktopNav isOpen={isOpen} locked={lockedSidebar} handleLocked={onClickLock} />
      </SDrawer>
    </SContainer>
  );
};
